import useSubadminBaseActions from './useSubadminBaseActions'

export default useSubadminBaseActions
